import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    category: '-1', // 资讯列表中分类
    // area: '1', // 福利列表中微信区、QQ区
    dataList: {}, // 文章列表信息
    bMemory: false, // 是否记住文章列表
    bCache: false, // 是否缓存promise
    // bSub: false, // 用户是否订阅
    // bsubscribe: false, // 用户是否关注
  },
  mutations: {
    setCategory(state, category) {
      state.category = category
    },
    setArea(state, area) {
      state.area = area
    },
    setDataList(state, dataList) {
      state.dataList = dataList
    },
    setMemory(state, bMemory) {
      state.bMemory = bMemory
    },
    setCache(state, bCache) {
      state.bCache = bCache
    },
    // setSub(state, bSub) {
    //   state.bSub = bSub
    // },
    // setSubscribe(state, bsubscribe) {
    //   state.bsubscribe = bsubscribe
    // },
  },
})
